var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[(_vm.$route.name !== 'login')?_c('app-drawer',{attrs:{"drawer":_vm.drawer},on:{"toggleDrawer":_vm.toggleDrawer}}):_vm._e(),(_vm.$route.name !== 'login')?_c('app-bar',{on:{"toggleDrawer":_vm.toggleDrawer}}):_vm._e(),_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }